module.exports = __webpack_public_path__ + "img/20210906-1630913567708386.117c1f56.png";